import {DataSurveyDynamicComponentHelper} from './data-survey-dynamic-component-helper';
import {ParticleService} from '@core/services/particle.service';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@shared/shared.module';
import {NgModule} from '@angular/core';
import {DataSurveyComponent} from './components/data-survey/data-survey.component';
import {RouterModule} from '@angular/router';
import {dataSurveyRoutes} from './data-survey.route';
import {DataSurveyExecutionComponent} from './components/data-survey-execution/data-survey-execution.component';
import {DataSurveyResponseComponent} from './components/data-survey-response/data-survey-response.component';
import {DataSurveyExecutionDetailsComponent} from './components/data-survey-execution-details/data-survey-execution-details.component';
import {EditSurveyComponent} from './components/edit-survey/edit-survey.component';
import {DataSurveyService} from './services/data-survey.service';
import {DataSurveyReducer} from './store/reducers/data-survey.reducers';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {DataSurveyEffect} from './store/effects/data-survey.effects';
import {ImportFieldSectionsComponent} from './components/import-field-sections/import-field-sections.component';
import {WorkflowModule} from '../workflow/workflow.module';
import {SurveyQuestionsStepComponent} from './components/survey-questions-step/survey-questions-step.component';
import {DataSurveyQuestionBuilderComponent} from './components/data-survey-question-builder/data-survey-question-builder.component';
import {DataSurveyFieldSelectorComponent} from './components/data-survey-field-selector/data-survey-field-selector.component';
import {SurveyDataStepComponent} from './components/survey-data-step/survey-data-step.component';
import {StartSurveyUsingGroupFilterComponent} from './components/start-survey-using-group-filter/start-survey-using-group-filter.component';
import {StartSurveyWithoutDataComponent} from './components/start-survey-without-data/start-survey-without-data.component';
import {StartSurveyUsingManualDataSelectionComponent} from './components/start-survey-using-manual-data-selection/start-survey-using-manual-data-selection.component';
import {SurveyExecutionSettingsComponent} from './components/survey-execution-settings/survey-execution-settings.component';
import {AddQuestionDialogComponent} from './components/add-question-dialog/add-question-dialog.component';
import {EditQuestionDialogComponent} from './components/edit-question-dialog/edit-question-dialog.component';
import { ImportFieldFromTemplateDialogComponent } from './components/import-field-from-template-dialog/import-field-from-template-dialog.component';
import { FormComponent } from './components/form/form.component';
import { SubmitResponseComponent } from './components/submit-response/submit-response.component';
import { DataSurveyCellEditorComponent } from './components/data-survey-cell-editor/data-survey-cell-editor.component';
import { AddCustomSurveyWorkflowComponent } from './components/add-custom-survey-workflow/add-custom-survey-workflow.component';
import { ExportSurveyResponseDialogComponent } from './components/export-survey-response-dialog/export-survey-response-dialog.component';
import { DataSurveyFormsComponent } from './components/data-survey-forms/data-survey-forms.component';
import { DataSurveyFormDesignerComponent } from './components/data-survey-form-designer/data-survey-form-designer.component';
import { CreateCustomFormDialogComponent } from './components/create-custom-form-dialog/create-custom-form-dialog.component';
import { ReportContentComponent } from './components/reports/report-content/report-content.component';
import { AddReportComponent } from './components/reports/add-report/add-report.component';
import { EditReportComponent } from './components/reports/edit-report/edit-report.component';
import { SelectSourceStepComponent } from './components/reports/select-source-step/select-source-step.component';
import { SelectReportFieldStepComponent } from './components/reports/select-report-field-step/select-report-field-step.component';
import { SelectDataStepComponent } from './components/reports/select-data-step/select-data-step.component';
import { ReportTaskContentComponent } from './components/reports/report-task-content/report-task-content.component';
import { SelectParticipantsStepComponent } from './components/reports/select-participants-step/select-participants-step.component';
import { ReportContactStatusCellViewerComponent } from './components/report-contact-status-cell-viewer/report-contact-status-cell-viewer.component';
import { DataSurveyResponseFormViewComponent } from './components/data-survey-response-form-view/data-survey-response-form-view.component';
import { ParticipantsForFillingReportComponent } from './components/reports/participants-for-filling-report/participants-for-filling-report.component';
import { FlowChartDesignerComponent } from './components/flow-chart/flow-chart-designer/flow-chart-designer.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FlowChartDataService } from './services/flow-chart-data.service';
import { FlowChartContainerComponent } from './components/flow-chart/flow-chart-container/flow-chart-container.component';
import { FlowChartTabViewComponent } from './components/flow-chart/flow-chart-tab-view/flow-chart-tab-view.component';
import { FlowChartPageViewComponent } from './components/flow-chart/flow-chart-page-view/flow-chart-page-view.component';
import { FlowChartGroupViewComponent } from './components/flow-chart/flow-chart-group-view/flow-chart-group-view.component';
import { FlowChartCollapsibleViewComponent } from './components/flow-chart/flow-chart-collapsible-view/flow-chart-collapsible-view.component';
import { AddConditonComponent } from './components/flow-chart/add-question/add-conditon.component';
import { FlowChartWorkflowStepComponent } from './components/flow-chart/flow-chart-workflow-step/flow-chart-workflow-step.component';
import { AddExecutionDialogComponent } from './components/add-execution-dialog/add-execution-dialog.component';
import { FlowChartResponseComponent } from './components/flow-chart/flow-chart-response/flow-chart-response.component';
import { FlowChartResponseGroupViewComponent } from './components/flow-chart/flow-chart-response-group-view/flow-chart-response-group-view.component';
import { DataSurveyContentComponent } from './components/data-survey-content/data-survey-content.component';
import { AddTemplateDialogComponent } from './components/add-template-dialog/add-template-dialog.component';
import { AddTopicDialogComponent } from './components/flow-chart/add-topic-dialog/add-topic-dialog.component';
import { RenameTitleDialogComponent } from './components/flow-chart/rename-title-dialog/rename-title-dialog.component';
import { MoveQuestionBetweenSectionDialogComponent } from './components/flow-chart/move-question-between-section-dialog/move-question-between-section-dialog.component';
import { DeleteSectionDialogComponent } from './components/flow-chart/delete-section-dialog/delete-section-dialog.component';
import { WorkflowRightSideBarDesignerComponent } from './components/flow-chart/workflow-right-side-bar/workflow-right-side-bar-designer/workflow-right-side-bar-designer.component';
import { WorkflowRightSideBarResponseComponent } from './components/flow-chart/workflow-right-side-bar/workflow-right-side-bar-response/workflow-right-side-bar-response.component';
import { WorkflowRightSideBarContainerComponent } from './components/flow-chart/workflow-right-side-bar/workflow-right-side-bar-container/workflow-right-side-bar-container.component';
import { DataSurveyReviewerRespondentContainerComponent } from './components/data-survey-reviewer-respondent-container/data-survey-reviewer-respondent-container.component';
import { DataSurveyLinkComponent } from './components/data-survey-link/data-survey-link.component';
import {PlatformToolFlowchartComponent} from './components/platform-tool-flowchart/platform-tool-flowchart.component';
import {PlatformToolDataSurveyResponseService} from './services/platform-tool-data-survey-response.service';
import { DataSurveyConfirmChangesDialogComponent } from './components/platform-tool-components/data-survey-confirm-changes-dialog/data-survey-confirm-changes-dialog.component';
import { StartDataSurveyDialogComponent } from './components/platform-tool-components/start-data-survey-dialog/start-data-survey-dialog.component';
import { SubmitResponseDialogComponent } from './components/platform-tool-components/submit-response-dialog/submit-response-dialog.component';
import {PlatformToolDataSurveyHandler} from './services/platform-tool-data-survey.handler';
import { EmphasizedCellViewerComponent } from './components/cell-viewers/emphasized-cell-viewer/emphasized-cell-viewer.component';
import { PinedHyperlinkCellViewerComponent } from './components/cell-viewers/pined-hyperlink-cell-viewer/pined-hyperlink-cell-viewer.component';
import { DataMappingOrbitaxToolCellViewerComponent } from './components/cell-viewers/data-mapping-orbitax-tool-cell-viewer/data-mapping-orbitax-tool-cell-viewer.component';
import { DataMappingOrbitaxFieldCellViewerComponent } from './components/cell-viewers/data-mapping-orbitax-field-cell-viewer/data-mapping-orbitax-field-cell-viewer.component';
import { DataCollectionDataMappingOrbitaxFieldCellViewerComponent } from './components/cell-viewers/data-collection-data-mapping-orbitax-field-cell-viewer/data-collection-data-mapping-orbitax-field-cell-viewer.component';
import { DataSurveyTopicTooltipComponent } from './components/data-survey-topic-tooltip/data-survey-topic-tooltip.component';
import {CommandService} from '@core/services/command.service';
import {PlatformCommand} from '@shared/commands/command-base';
import { DesignQuentionareDialogComponent } from './components/flow-chart/eat-dialogs/design-quentionare-dialog/design-quentionare-dialog.component';
import { ResponseQuentionareDialogComponent } from './components/flow-chart/eat-dialogs/response-quentionare-dialog/response-quentionare-dialog.component';
import { PlatformToolQuestionnaireComponent } from './components/platform-tool-components/platform-tool-questionnaire/platform-tool-questionnaire.component';
import { PlatformToolQuestionnaireResponseComponent } from './components/platform-tool-components/platform-tool-questionnaire-response/platform-tool-questionnaire-response.component';
import { PlatformToolQuestionResponseGroupComponent } from './components/platform-tool-components/platform-tool-question-response-group/platform-tool-question-response-group.component';
import { PlatformToolRichDocumentEditorComponent } from './components/platform-tool-components/platform-tool-rich-document-editor/platform-tool-rich-document-editor.component';
import { PlatformToolQuestionnaireDesignGroupComponent } from './components/platform-tool-components/platform-tool-questionnaire-design-group/platform-tool-questionnaire-design-group.component';
import { PlatformToolAddSnippetEditorComponent } from './components/platform-tool-components/platform-tool-add-snippet-editor/platform-tool-add-snippet-editor.component';
import {CreateSurveyExecutionLinkCommandHandler} from "@features/data-survey/command-handlers/create-survey-execution-link-command-handler";
import {ReportTaskContentHandler} from '@features/data-survey/components/reports/report-task-content/report-task-content-handler';
import { PlatformToolEditSectionEditorComponent } from './components/platform-tool-components/platform-tool-edit-section-editor/platform-tool-edit-section-editor.component';
import {PlatformToolDataSurveyReportContentHandler} from "@features/data-survey/services/platform-tool-data-survey-report-content.handler";
import {QuillModule} from 'ngx-quill';

@NgModule({
  imports: [
    QuillModule.forRoot(),
    CommonModule,
    SharedModule,
    WorkflowModule,
    RouterModule.forChild(dataSurveyRoutes),
    StoreModule.forFeature('data-survey-state', DataSurveyReducer),
    EffectsModule.forFeature([DataSurveyEffect]),
    DragDropModule,
  ],
  declarations: [
    AddExecutionDialogComponent,
    DataSurveyComponent,
    DataSurveyExecutionComponent,
    DataSurveyResponseComponent,
    DataSurveyExecutionDetailsComponent,
    EditSurveyComponent,
    ImportFieldSectionsComponent,
    SurveyQuestionsStepComponent,
    DataSurveyQuestionBuilderComponent,
    DataSurveyFieldSelectorComponent,
    SurveyDataStepComponent,
    StartSurveyUsingGroupFilterComponent,
    StartSurveyWithoutDataComponent,
    StartSurveyUsingManualDataSelectionComponent,
    SurveyExecutionSettingsComponent,
    AddQuestionDialogComponent,
    EditQuestionDialogComponent,
    ImportFieldFromTemplateDialogComponent,
    FormComponent,
    SubmitResponseComponent,
    DataSurveyCellEditorComponent,
    AddCustomSurveyWorkflowComponent,
    ExportSurveyResponseDialogComponent,
    DataSurveyFormsComponent,
    DataSurveyFormDesignerComponent,
    CreateCustomFormDialogComponent,
    ReportContentComponent,
    AddReportComponent,
    EditReportComponent,
    SelectSourceStepComponent,
    SelectReportFieldStepComponent,
    SelectDataStepComponent,
    ReportTaskContentComponent,
    SelectParticipantsStepComponent,
    ReportContactStatusCellViewerComponent,
    DataSurveyResponseFormViewComponent,
    ParticipantsForFillingReportComponent,
    FlowChartDesignerComponent,
    FlowChartResponseComponent,
    FlowChartContainerComponent,
    FlowChartTabViewComponent,
    FlowChartPageViewComponent,
    FlowChartGroupViewComponent,
    FlowChartResponseGroupViewComponent,
    FlowChartCollapsibleViewComponent,
    AddConditonComponent,
    FlowChartWorkflowStepComponent,
    DataSurveyContentComponent,
    AddTemplateDialogComponent,
    AddTopicDialogComponent,
    RenameTitleDialogComponent,
    MoveQuestionBetweenSectionDialogComponent,
    DeleteSectionDialogComponent,
    WorkflowRightSideBarDesignerComponent,
    WorkflowRightSideBarResponseComponent,
    WorkflowRightSideBarContainerComponent,
    DataSurveyReviewerRespondentContainerComponent,
    DataSurveyLinkComponent,
    PlatformToolFlowchartComponent,
    PlatformToolQuestionnaireComponent,
    DataSurveyConfirmChangesDialogComponent,
    PlatformToolAddSnippetEditorComponent,
    PlatformToolAddSnippetEditorComponent,
    StartDataSurveyDialogComponent,
    SubmitResponseDialogComponent,
    EmphasizedCellViewerComponent,
    PinedHyperlinkCellViewerComponent,
    DataMappingOrbitaxToolCellViewerComponent,
    DataMappingOrbitaxFieldCellViewerComponent,
    DataCollectionDataMappingOrbitaxFieldCellViewerComponent,
    DataSurveyTopicTooltipComponent,
    DesignQuentionareDialogComponent,
    ResponseQuentionareDialogComponent,
    PlatformToolQuestionnaireResponseComponent,
    PlatformToolQuestionResponseGroupComponent,
    PlatformToolRichDocumentEditorComponent,
    PlatformToolQuestionnaireDesignGroupComponent,
    PlatformToolAddSnippetEditorComponent,
    PlatformToolEditSectionEditorComponent
  ],
  exports: [
    DataSurveyComponent,
    ImportFieldSectionsComponent,
    SurveyQuestionsStepComponent,
    FlowChartWorkflowStepComponent,
    WorkflowRightSideBarDesignerComponent,
    WorkflowRightSideBarResponseComponent,
    WorkflowRightSideBarContainerComponent,
    PlatformToolFlowchartComponent,
    PlatformToolQuestionnaireComponent,
    PlatformToolQuestionnaireDesignGroupComponent,
    PlatformToolQuestionnaireResponseComponent,
    PlatformToolQuestionResponseGroupComponent,
    FlowChartDesignerComponent,
    FlowChartResponseComponent,
    PlatformToolRichDocumentEditorComponent
  ],
  providers: [
    DataSurveyService,
    FlowChartDataService,
    PlatformToolDataSurveyResponseService
  ]
})
export class DataSurveyModule {
  constructor(protected particleService: ParticleService,
              protected platformToolDataSurveyResponseService: PlatformToolDataSurveyResponseService,
              platformToolDataSurveyHandler: PlatformToolDataSurveyHandler,
              platformToolDataSurveyReportContentHandler: PlatformToolDataSurveyReportContentHandler,
              private createSurveyExecutionLinkCommandHandler: CreateSurveyExecutionLinkCommandHandler,
              private reportTaskContentHandler: ReportTaskContentHandler,
              private commandService: CommandService
  ) {
    DataSurveyDynamicComponentHelper.init();
    DataSurveyDynamicComponentHelper.register('PlatformToolDataSurveyResponseService', platformToolDataSurveyResponseService);
    DataSurveyDynamicComponentHelper.register('PlatformToolDataSurveyHandler', platformToolDataSurveyHandler);
    DataSurveyDynamicComponentHelper.register('PlatformToolDataSurveyReportContentHandler', platformToolDataSurveyReportContentHandler);
    DataSurveyDynamicComponentHelper.register('ReportTaskContentHandler', reportTaskContentHandler);

    let command = new PlatformCommand('CreateSurveyToolLinkCommand', 'DataSurveyApi');
    command.fieldValues['SelectedTabId'] = 'ActiveSurvey';
    this.commandService.registrPlatformLinkCommand('/data-survey', command);
    /*let command = new PlatformCommand('EntityDesignerLinkCommand', 'EntityChartApi');
    this.commandService.registrPlatformLinkCommand('/data-survey', command);*/

    command = new PlatformCommand('CreateSurveyToolLinkCommand', 'DataSurveyApi');
    command.fieldValues['SelectedTabId'] = 'SurveyTemplate';
    this.commandService.registrPlatformLinkCommand('/data-survey/templates', command);

    command = new PlatformCommand('CreateSurveyToolLinkCommand', 'DataSurveyApi');
    command.fieldValues['SelectedTabId'] = 'ActiveSurveyParticipating';
    this.commandService.registrPlatformLinkCommand('/data-survey/participating', command);

    command = new PlatformCommand('CreateSurveyToolLinkCommand', 'DataSurveyApi');
    command.fieldValues['SelectedTabId'] = 'ScheduledDataSurvey';
    this.commandService.registrPlatformLinkCommand('/data-survey/scheduled', command);
    DataSurveyDynamicComponentHelper.register('CreateSurveyExecutionLinkCommandHandler', createSurveyExecutionLinkCommandHandler);
    DataSurveyDynamicComponentHelper.register('EditReportComponent', EditReportComponent);
  }
}
